import { Grid, Paper } from '@material-ui/core'
import { Fragment } from 'react'
import { energyCertifications } from '../../../../../utils/validation/energyCertifications'
import { getValueObject } from '../../../../../utils/validation/forms'
import { getPostalAreaInitialValue } from '../../../../../utils/validation/listOfCitiesForPostalArea'
import ApartmentInformationForm from '../../../Forms/ApartmentInformationForm'
import { getApartmentInitialValues } from '../../../Forms/values/apartmentInitialValues'
import { BeforeLoginStepProps } from '../../BeforeLoginStepper'

const ApartmentInfoStep = ({
  currentStep,
  apartment,
  classes,
  saveApartmentInfo,
  doStepBack,
  beforeLogin,
  isMobile
}: BeforeLoginStepProps) => {
  return (
    <Fragment>
      {currentStep >= 0 && currentStep < 9 && (
        <Grid container direction='row' alignItems='center' justify='center'>
          <Grid item sm={12} md={12}>
            <Paper className={classes.formPaper}>
              <ApartmentInformationForm
                classes={classes}
                initialValues={{
                  ...getApartmentInitialValues(apartment?.information),
                  ...apartment?.switchedData,
                  energyCertification:
                    getValueObject(
                      apartment,
                      energyCertifications,
                      'energyCertification'
                    ) || energyCertifications[0],
                  postalArea: getPostalAreaInitialValue(
                    apartment?.information?.postalArea
                  )
                }}
                updateApartmentInformation={saveApartmentInfo}
                isDisabled={false}
                currentStep={currentStep}
                doStepBack={doStepBack}
                beforeLogin={beforeLogin}
                isMobile={isMobile}
              />
            </Paper>
          </Grid>
        </Grid>
      )}
    </Fragment>
  )
}

export default ApartmentInfoStep
